/**
 * Renders a single OPSI ACF flexible-content row using only fields for its layout type.
 */

import { OpsiAccordion } from "./parts/OpsiAccordion";
import { OpsiAppendixTable } from "./parts/OpsiAppendixTable";
import { OpsiBoxSlider } from "./parts/OpsiBoxSlider";
import { OpsiFullWidthText } from "./parts/OpsiFullWidthText";
import { OpsiHeaderWithArrows } from "./parts/OpsiHeaderWithArrows";
import { OpsiImage } from "./parts/OpsiImage";
import { OpsiLargeBoxSlider } from "./parts/OpsiLargeBoxSlider";
import { OpsiSplitParagraph } from "./parts/OpsiSplitParagraph";
import { OpsiStatCard } from "./parts/OpsiStatCard";
import { OpsiUrlLinks } from "./parts/OpsiUrlLinks";
import { OPSI_SECTION_SPACING } from "./utils/opsiHelpers";
import { getOpsiSectionFieldKeys } from "./utils/opsiSectionFields";
import { OpsiSmallImage } from "./parts/OpsiSmallImage";
import { OpsiIconBoxImage } from "./parts/OpsiIconBoxImage";

const renderField = (section, fieldKey) => {
  switch (fieldKey) {
    case "fullwidthtext":
      return <OpsiFullWidthText key={fieldKey} data={section.fullwidthtext} />;
    case "statcard":
      return <OpsiStatCard key={fieldKey} data={section.statcard} />;
    case "split_paragraph_text":
      return (
        <OpsiSplitParagraph key={fieldKey} data={section.split_paragraph_text} />
      );
    case "header_with_arrows":
      return (
        <OpsiHeaderWithArrows key={fieldKey} data={section.header_with_arrows} />
      );
    case "image":
      return <OpsiImage key={fieldKey} data={section.image} />;
    case "small_image":
        return <OpsiSmallImage key={fieldKey} data={section.small_image} />;
    case "icon_box_image":
          return <OpsiIconBoxImage key={fieldKey} data={section.icon_box_image} />;
    case "box_slider_section":
      return (
        <OpsiBoxSlider
          key={fieldKey}
          data={section.box_slider_section}
          variant="box"
        />
      );
    case "large_box_slider_section":
      return (
        <OpsiLargeBoxSlider key={fieldKey} data={section.large_box_slider_section} />
      );
    case "accordion":
      return <OpsiAccordion key={fieldKey} data={section.accordion} />;
    case "url_links":
      return <OpsiUrlLinks key={fieldKey} data={section.url_links} />;
    case "appendix_table":
      return <OpsiAppendixTable key={fieldKey} data={section.appendix_table} />;
    default:
      return null;
  }
};

export const OpsiSection = ({ section, id }) => {
  const sectionType = section?.choose_a_section;
  const fieldKeys = getOpsiSectionFieldKeys(sectionType);

  if (!fieldKeys.length) {
    return (
      <div
        id={id}
        className={`opsi-section opsi-section--unknown w-full px-0 ${OPSI_SECTION_SPACING}`}
        data-opsi-section={sectionType || "unknown"}
      >
        <p>Unsupported OPSI section: {sectionType || "unknown"}</p>
      </div>
    );
  }

  return (
    <div
      id={id}
      className={`opsi-section opsi-section--${String(sectionType).toLowerCase()} w-full px-0 ${OPSI_SECTION_SPACING} [&>[data-opsi-part]:mt-0 [&>[data-opsi-part]:mb-0 [&>[data-opsi-part]:not(:last-child)]:mb-6`}
      data-opsi-section={sectionType}
    >
      {fieldKeys.map((fieldKey) => renderField(section, fieldKey))}
    </div>
  );
};
